import { createContext, useContext } from 'react';

import type { ReactFCWithChildren } from '@widget/types/ReactFCWithChildren';
import type { TrustIcon } from './types';

type Props = {
  trustIcons?: TrustIcon[];
};

const TrustIconContext = createContext<Props['trustIcons']>({} as Props['trustIcons']);

export const TrustIconProvider: ReactFCWithChildren<Props> = ({ trustIcons, children }) => {
  return <TrustIconContext.Provider value={trustIcons}>{children}</TrustIconContext.Provider>;
};

export const useTrustIcon = (): Props['trustIcons'] => {
  const trustIcon = useContext(TrustIconContext);

  return trustIcon;
};
